// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2FL3G","calendarButtons":"ClockData_calendarButtons__2yVkl"};